import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
// import hayatin from '../../assets/images/hayatin.jpg';
// import homeicon from '../../assets/home-images/homeicon.jpg';
// import experienceicon from '../../assets/home-images/experienceicon.jpg';
import search from '../../assets/home-images/search.png';
import downarrow from '../../assets/home-images/downarrow.png';
// import homeicon from '../../assets/home-images/homeicon.jpg';
// import experienceicon from '../../assets/home-images/experienceicon.jpg';
// import businessicon from '../../assets/home-images/businessicon.jpg';
import Navbar from "../common-component/navbar/Navbar";
const SubmissionGuidelines = () => {

    const [showPopup, setShowPopup] = useState(false);
    const [language, setLanguage] = useState("english");
    const location = useLocation();

    const togglePopup = () => setShowPopup(!showPopup);

    const handleLanguageChange = (lang) => {
        setLanguage(lang);
        setShowPopup(false);
    };


    return (
        <div>
            <Navbar dir={language === "arabic" ? "rtl" : "ltr"} />

            <div className="experience-main-layout">
                <aside className="left-section" dir={language === "arabic" ? "rtl" : "ltr"}>
                    <div className="searchbox">
                        <img src={search} alt="search" />
                        <input type="text" placeholder="Search..." />
                    </div>
                    <div className="left-menu-content">
                        <div
                            className="agreement-contentname"
                            style={{
                                backgroundColor: location.pathname === "/merchantagreement" ? "#ECF3FF" : "transparent"
                            }}
                        >
                            <Link to="/merchantagreement" className="no-underline">
                                <p>Service Provider Agreement</p>
                            </Link>
                        </div>

                        <div
                            className="agreement-contentname"
                            style={{
                                backgroundColor: location.pathname === "/submissionguidelines" ? "#ECF3FF" : "transparent"
                            }}
                        >
                            <Link to="/submissionguidelines" className="no-underline">
                                <p>Submission Guidelines</p>
                            </Link>
                        </div>
                        <div
                            className="agreement-contentname"
                            style={{
                                backgroundColor: location.pathname === "/privacypolicy" ? "#ECF3FF" : "transparent"
                            }}
                        >
                            <Link to="/privacypolicy" className="no-underline">
                                <p>Privacy Policy</p>
                            </Link>
                        </div>

                        <div
                            className="agreement-contentname"
                            style={{
                                backgroundColor: location.pathname === "/termsofuseforusers" ? "#ECF3FF" : "transparent"
                            }}
                        >
                            <Link to="/termsofuseforusers" className="no-underline">
                                <p>Terms Of Use For Users</p>
                            </Link>
                        </div>
                        <div
                            className="agreement-contentname"
                            style={{
                                backgroundColor: location.pathname === "/ruleofuse" ? "#ECF3FF" : "transparent"
                            }}
                        >
                            <Link to="/ruleofuse" className="no-underline">
                                <p>Rule Of Use</p>
                            </Link>
                        </div>


                    </div>
                    <div className="divider-line"></div>
                    <div className="footer-links">
                        <div className="footer-column">
                            <span>About</span>
                            {/* <span>Business Pro</span> */}
                            <div className="content-arrow">
                                <Link to="/merchantagreement" className="privacy-link">
                                    <span>Privacy & Terms</span>
                                    <img src={downarrow} alt="down arrow" />
                                </Link>
                            </div>
                        </div>
                        {/* <div className="footer-column">
                                           <span>Help Center</span>
                                           <span>FAQ</span>
                                           <span>Careers</span>
                                       </div> */}
                        <div className="footer-column">

                            <div className="content-arrow" onClick={togglePopup}>
                                <span className="language-text">
                                    {language === "english" ? "Language" : "اللغة"}
                                </span>
                                <img src={downarrow} alt="down arrow" className="arrow-icon" />

                                {showPopup && (
                                    <div className="language-popup">
                                        <label>
                                            <input
                                                type="radio"
                                                name="language"
                                                value="english"
                                                checked={language === "english"}
                                                onChange={() => handleLanguageChange("english")}
                                            />
                                            English
                                        </label>
                                        <label>
                                            <input
                                                type="radio"
                                                name="language"
                                                value="arabic"
                                                checked={language === "arabic"}
                                                onChange={() => handleLanguageChange("arabic")}
                                            />
                                            Arabic
                                        </label>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                </aside>


                <main className="merchant-mid-section-container" dir={language === "arabic" ? "rtl" : "ltr"}>
                    <div className="agreement-heading">
                        <h4>
                            {language === "english"
                                ? "Mobile Application End User License Agreement/ Hayat In L.L.C- S.P.C"
                                : "اتفاقية ترخيص المستخدم النهائي لتطبيقات الهاتف المحمول/ حياة إن ذ.م.م- ش.ش.و"}
                        </h4>
                    </div>

                    <div className="merchant-mid-section-body">
                        <div className="agreement-subheading">
                            <h5>
                                {language === "english"
                                    ? "Effective as of: Feb First, 2025" : " يسري اعتبارًا من: الأول من فبراير 2025"
                                }


                            </h5>
                            <p>
                                {language === "english" ? (
                                    <>
                                        This Mobile Application End User License Agreement ("Agreement") is a binding agreement between you ("End User" or "you") and Hayat In L.L.C- S.P.C. ("Company"). This Agreement governs your use of this mobile application for Android, and iOS (collectively, including all related documentation, the "Application") on a single mobile device owned or otherwise controlled by you (the "Application"). The Application is licensed, not sold, to you.
                                    </>
                                ) : (
                                    <>
                                        اتفاقية ترخيص المستخدم النهائي لتطبيقات الهاتف المحمول ("الاتفاقية") هي اتفاقية ملزمة بينك ("المستخدم النهائي" أو "أنت") وشركة حياة إن ذ.م.م- ش.ش.و ("الشركة"). تحكم هذه الاتفاقية استخدامك لتطبيق الهاتف المحمول هذا لنظامي التشغيل Android وiOS (بشكل جماعي، بما في ذلك جميع الوثائق ذات الصلة، "التطبيق") على جهاز محمول واحد تملكه أو تتحكم فيه بطريقة أخرى ("التطبيق"). التطبيق مرخص لك، وليس مباعًا.
                                    </>
                                )}


                            </p>

                            <p>
                                {language === "english" ? (
                                    <>
                                        WAIV THE APPLICATION, YOU (A) ACKNOWLEDGE THAT YOU HAVE READ AND UNDERSTAND THIS AGREEMENT; (B) REPRESENT THAT YOU ARE 16 YEARS OF AGE OR OLDER/OF LEGAL AGE TO ENTER INTO A BINDING AGREEMENT; AND (C) ACCEPT THIS AGREEMENT AND AGREE THAT YOU ARE LEGALLY BOUND BY ITS TERMS. IF YOU DO NOT AGREE TO THESE TERMS, DO NOT DOWNLOAD, INSTALL, OR USE THE APPLICATION AND DELETE IT FROM YOUR MOBILE DEVICE.
                                    </>
                                ) : (
                                    <>
                                        عند التنازل عن الطلب، فإنك (أ) تقر بأنك قد قرأت وفهمت هذه الاتفاقية؛ (ب) الإقرار بأن عمرك 16 عامًا أو أكبر، السن القانوني للدخول في اتفاقية ملزمة؛ و(ج) قبول هذه الاتفاقية والموافقة على أنك ملتزم قانونًا بشروطها. إذا لم توافق على هذه الشروط، فلا تقم بتنزيل التطبيق أو تثبيته أو استخدامه وحذفه من جهازك المحمول.                                    </>
                                )
                                }

                            </p>
                        </div>

                        <div className="defined-terms">
                            <h6>
                                {language === "english" ? (
                                    <>1. License Grant:</>
                                ) : (
                                    <>
                                        1. 	منح الترخيص:
                                    </>
                                )
                                }
                            </h6>
                            <p>
                                {
                                    language === "english" ? (
                                        <>
                                            Subject to the terms of this Agreement, Hayat In L.L.C- S.P.C grants you a limited, non-exclusive, and non-transferable license to download, install, and use the Application for your personal, non-revenue generating use on a single mobile device owned or otherwise controlled by you ("Mobile Device").                                        </>
                                    ) : (
                                        <>
                                            وفقًا لشروط هذه الاتفاقية، تمنحك شركة حياة إن ذ.م.م- ش.ش.و ترخيصًا محدودًا وغير حصري وغير قابل للتحويل لتنزيل التطبيق وتثبيته واستخدامه لاستخدامك الشخصي الذي لا يدر دخلاً على جهاز محمول واحد. المملوكة لك أو الخاضعة لسيطرتك ("الجهاز المحمول").
                                        </>
                                    )
                                }
                            </p>

                        </div>

                        <div className="defined-terms">
                            <h6>{language === "english" ? (
                                <>2. License Restrictions:</>
                            ) : (
                                <> 2.	قيود الترخيص:</>
                            )
                            }
                            </h6>
                            <p>{language === "english" ? (
                                <>You shall not:</>
                            ) : (
                                <>
                                    غير مصرح لك:
                                </>
                            )
                            }
                            </p>
                            <div className="defined-terms-list">
                                <div className="defined-terms-listcontent" >
                                    <span>a.</span>
                                    <p>
                                        {
                                            language === "english" ? (
                                                <>copy the Application, except as expressly permitted by this license.</>
                                            ) : (
                                                <>
                                                    نسخ التطبيق، باستثناء ما يسمح به هذا الترخيص صراحة.
                                                </>
                                            )
                                        }
                                    </p>
                                </div>
                                <div className="defined-terms-listcontent" >
                                    <span>b.</span>
                                    <p>
                                        {
                                            language === "english" ? (
                                                <>modify, translate, adapt, or otherwise create derivative works or improvements, whether or not patentable, of the Application.</>
                                            ) : (
                                                <>
                                                    تعديل أو ترجمة أو تكييف أو إنشاء أعمال مشتقة أو تحسينات للتطبيق، سواء كانت قابلة للحصول على براءة اختراع أم لا.
                                                </>
                                            )
                                        }
                                    </p>
                                </div>
                                <div className="defined-terms-listcontent" >
                                    <span>c.</span>
                                    <p>
                                        {language === "english" ? (
                                            <>reverse engineer, disassemble, decompile, decode, or otherwise attempt to derive or gain access to the source code of the Application or any part thereof.</>
                                        ) : (
                                            <>
                                                إجراء هندسة عكسية أو تفكيك أو فك تشفير أو محاولة استخلاص أو الوصول إلى الكود المصدري للتطبيق أو أي جزء منه.
                                            </>
                                        )
                                        }
                                    </p>
                                </div>
                                <div className="defined-terms-listcontent" >
                                    <span>d.</span>
                                    <p>
                                        {language === "english" ? (
                                            <>remove, delete, alter, or obscure any trademarks or any copyright, trademark, patent, or other intellectual property or proprietary rights notices from the Application, including any copy thereof.</>
                                        ) : (
                                            <>
                                                إزالة أو حذف أو تغيير أو حجب أي علامات تجارية أو أي حقوق نشر أو علامة تجارية أو براءة اختراع أو غيرها من إشعارات الملكية الفكرية أو حقوق الملكية من التطبيق، بما في ذلك أي نسخة منها.
                                            </>
                                        )
                                        }
                                    </p>
                                </div>
                                <div className="defined-terms-listcontent" >
                                    <span>e.</span>
                                    <p>
                                        {language === "english" ? (
                                            <>
                                                rent, lease, lend, sell, sublicense, assign, distribute, publish, transfer, or otherwise make available the Application, or any features or functionality of the Application, to any third party for any reason, including by making the Application available on a network where it is capable of being accessed by more than one device at any time.
                                            </>
                                        ) : (
                                            <>
                                                تأجير أو إقراض أو بيع أو ترخيص من الباطن أو التنازل أو توزيع أو نشر أو نقل أو إتاحة التطبيق أو أي ميزات أو وظائف في التطبيق لأي طرف ثالث لأي سبب من الأسباب، بما في ذلك عن طريق إتاحة التطبيق على الشبكة حيث يمكن الوصول إليها من قبل أكثر من جهاز واحد في أي وقت.
                                            </>
                                        )
                                        }
                                    </p>
                                </div>
                                <div className="defined-terms-listcontent" >
                                    <span>f.</span>
                                    <p>{language === "english" ? (
                                        <>
                                            remove, disable, circumvent, or otherwise create or implement any workaround to any copy protection, rights management, or security features in or protecting the Application.
                                        </>
                                    ) : (
                                        <>
                                            إزالة أو تعطيل أو التحايل أو إنشاء أو تنفيذ أي حل بديل لأي حماية للنسخ أو إدارة الحقوق أو ميزات الأمان في التطبيق أو حمايته.
                                        </>
                                    )
                                    }
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="defined-terms">
                            <h6>{language === "english" ? (
                                <>3. Reservation of Rights:</>
                            ) : (
                                <> 3. حفظ الحقوق:</>
                            )
                            }
                            </h6>
                            <p>
                                {language === "english" ? (
                                    <>
                                        You acknowledge and agree that the Application is provided under license, and not sold, to you. You do not acquire any ownership interest in the Application under this Agreement, or any other rights thereto other than to use the Application in accordance with the license granted, and subject to all terms, conditions, and restrictions, under this Agreement. Hayat In L.L.C- S.P.C reserves and shall retain its entire right, title, and interest in and to the Application, including all copyrights, trademarks, and other intellectual property rights therein or relating thereto, except as expressly granted to you in this Agreement.
                                    </>
                                ) : (
                                    <>
                                        أنت تقر وتوافق على أن التطبيق مقدم بموجب ترخيص، ولا يتم بيعه لك. لا تحصل على أي حصة ملكية في التطبيق بموجب هذه الاتفاقية، أو أي حقوق أخرى تتعلق به بخلاف استخدام التطبيق وفقًا للترخيص الممنوح، ومع مراعاة جميع الشروط والأحكام والقيود، بموجب هذه الاتفاقية. تحتفظ شركة حياة إن بحقها وملكيتها ومصلحتها بالكامل في التطبيق وفيما يتعلق به، بما في ذلك جميع حقوق الطبع والنشر والعلامات التجارية وحقوق الملكية الفكرية الأخرى الموجودة فيه أو المتعلقة به، باستثناء ما تم منحه لك صراحةً في هذه الاتفاقية.
                                    </>
                                )
                                }
                            </p>
                        </div>

                        <div className="defined-terms">
                            <h6>{language === "english" ? (
                                <>4. Collection and Use of Your Information:</>
                            ) : (
                                <> 4. جمع واستخدام المعلومات الخاصة بك:</>
                            )
                            }
                            </h6>
                            <p>
                                {language === "english" ? (
                                    <>
                                        When using the Application, your personal information may be collected and processed as detailed in our  <a href="#privacy policy" className="hayat-link">privacy Notice</a>. By utilizing the Application, you confirm that you have reviewed the Privacy Notice and comprehended the information provided therein. Furthermore, by downloading, installing, or using the Application, you agree that Hayat In L.L.C- S.P.C may automatically collect information about your Mobile Device and your Application usage. You may also be asked to furnish certain information about yourself as a prerequisite for accessing the Application or its features. The Application may also facilitate the sharing of information about yourself with others. All information collected through or in relation to the Application is governed by our Privacy Policy. By downloading, installing, using, and providing information to or through the Application, you consent to all actions undertaken by us concerning your information, in accordance with the <a href="#privacy policy" className="hayat-link">privacy Notice</a>.
                                    </>
                                ) : (
                                    <>
                                        عند استخدام التطبيق، قد يتم جمع معلوماتك الشخصية ومعالجتها على النحو المفصل في <a href="#privacy policy" className="hayat-link">إشعار الخصوصية</a> الخاص بنا. من خلال استخدام التطبيق، فإنك تؤكد أنك قمت بمراجعة <a href="#privacy policy" className="hayat-link">إشعار الخصوصية</a> وفهم المعلومات المقدمة فيه. علاوة على ذلك، من خلال تنزيل التطبيق أو تثبيته أو استخدامه، فإنك توافق على أنه يجوز لشركة حياة إن جمع معلومات تلقائيًا حول جهازك المحمول واستخدامك للتطبيق. قد يُطلب منك أيضًا تقديم معلومات معينة عن نفسك كشرط أساسي للوصول إلى التطبيق أو ميزاته. قد يسهل التطبيق أيضًا مشاركة المعلومات الخاصة بك مع الآخرين. تخضع جميع المعلومات التي يتم جمعها من خلال التطبيق أو فيما يتعلق به لسياسة الخصوصية الخاصة بنا. من خلال تنزيل المعلومات وتثبيتها واستخدامها وتوفيرها للتطبيق أو من خلاله، فإنك توافق على جميع الإجراءات التي نتخذها فيما يتعلق بمعلوماتك، وفقًا لسياسة الخصوصية.
                                    </>
                                )}
                            </p>

                        </div>

                        <div className="defined-terms">
                            <h6>{language === "english" ? (
                                <>5. Updates:</>
                            ) : (
                                <> 5. التحديثات:</>
                            )
                            }
                            </h6>
                            <p> {language === "english" ? (
                                <>
                                    Hayat In L.L.C- S.P.C, at its sole discretion, may develop and provide Application updates, encompassing upgrades, bug fixes, patches, error corrections, and/or new features (collectively referred to as "Updates"). These Updates may also include modifications or deletions of certain features and functionalities. You acknowledge that Hayat In L.L.C- S.P.C is not obliged to furnish any Updates or maintain any specific features or functionalities. Depending on your Mobile Device settings, when your device is connected to the internet:
                                </>
                            ) : (
                                <>
                                    يجوز لشركة حياة إن، وفقًا لتقديرها الخاص، تطوير وتوفير تحديثات التطبيق، بما في ذلك الترقيات وإصلاحات الأخطاء والتصحيحات وتصحيحات الأخطاء و/أو الميزات الجديدة (يشار إليها مجتمعة باسم "التحديثات"). قد تتضمن هذه التحديثات أيضًا تعديلات أو عمليات حذف لبعض الميزات والوظائف. أنت تقر بأن شركة حياة إن ليست ملزمة بتقديم أي تحديثات أو الحفاظ على أي ميزات أو وظائف محددة. اعتمادًا على إعدادات جهازك المحمول، عندما يكون جهازك متصلاً بالإنترنت:
                                </>
                            )}</p>
                            <div className="defined-terms-list">
                                <div className="defined-terms-listcontent" >
                                    <span>{language === "english" ? (
                                        <>a.</>
                                    ) : (
                                        <>أ. </>
                                    )}</span>
                                    <p>
                                        {
                                            language === "english" ? (
                                                <>The Application may automatically download and install all available Updates; or</>
                                            ) : (
                                                <>
                                                    قد يقوم التطبيق بتنزيل كافة التحديثات المتوفرة وتثبيتها تلقائيًا؛ أو
                                                </>
                                            )
                                        }
                                    </p>
                                </div>
                                <div className="defined-terms-listcontent" >
                                    <span>{language === "english" ? (
                                        <>b.</>
                                    ) : (
                                        <>ب. </>
                                    )}</span>
                                    <p>
                                        {
                                            language === "english" ? (
                                                <>You may receive notice of or be prompted to download and install available Updates.</>
                                            ) : (
                                                <>
                                                    قد تتلقى إشعارًا أو يُطلب منك تنزيل التحديثات المتوفرة وتثبيتها.
                                                </>
                                            )
                                        }
                                    </p>
                                </div>

                            </div>

                            <p> {language === "english" ? (
                                <>
                                    Promptly downloading and installing all Updates is your responsibility. Failure to do so may result in the Application or certain parts thereof not functioning properly. You also agree that all Updates will be considered part of the Application and subject to all terms and conditions outlined in this Agreement.                                </>
                            ) : (
                                <>
                                    تقع على عاتقك مسؤولية تنزيل جميع التحديثات وتثبيتها على الفور. قد يؤدي عدم القيام بذلك إلى عدم عمل التطبيق أو أجزاء معينة منه بشكل صحيح. أنت توافق أيضًا على أن جميع التحديثات ستعتبر جزءًا من التطبيق وتخضع لجميع الشروط والأحكام الموضحة في هذه الاتفاقية.
                                </>
                            )}</p>
                        </div>

                        <div className="defined-terms">
                            <h6>{language === "english" ? (
                                <>6. Third-Party Materials:</>
                            ) : (
                                <>6. محتوى الطرف الثالث:</>
                            )
                            }
                            </h6>
                            <p>{language === "english" ?
                                (
                                    <>
                                        The Application may display, include, or make available third-party content (including data, information, applications, and other products, services, and/or materials) or provide links to third-party websites or services, including through third-party advertising ("Third-Party Materials"). You acknowledge and agree that Hayat In L.L.C- S.P.C is not responsible for Third-Party Materials, including their accuracy, completeness, timeliness, validity, copyright compliance, legality, decency, quality, or any other aspect thereof. Hayat In L.L.C- S.P.C does not assume and will not have any liability or responsibility to you or any other person or entity for any Third-Party Materials. Third-party materials and links thereto are provided solely as a convenience to you, and you access and use them entirely at your own risk and subject to such third parties' terms and conditions.
                                    </>
                                ) : (
                                    <> قد يعرض التطبيق محتوى جهة خارجية أو يتضمنه أو يتيحه (بما في ذلك البيانات والمعلومات والتطبيقات والمنتجات والخدمات و/أو المواد الأخرى) أو يوفر روابط لمواقع أو خدمات تابعة لجهات خارجية، بما في ذلك من خلال إعلانات الجهات الخارجية ("محتوى الطرف الثالث"). أنت تقر وتوافق على أن شركة حياة إن ليست مسؤولة عن محتوى الطرف الثالث، بما في ذلك دقتها واكتمالها وحسن توقيتها وصلاحيتها والامتثال لحقوق الطبع والنشر والشرعية واللياقة والجودة أو أي جانب آخر منها. شركة حياة إن لا تتحمل ولن تتحمل أي التزام أو مسؤولية تجاهك أو تجاه أي شخص أو كيان آخر عن أي مواد خاصة بطرف ثالث. يتم توفير محتوى الطرف الثالث والروابط الخاصة به فقط كوسيلة راحة لك، ويمكنك الوصول إليها واستخدامها بالكامل على مسؤوليتك الخاصة وتخضع لشروط وأحكام هذه الأطراف الخارجية.</>
                                )}</p>
                        </div>

                        <div className="defined-terms">
                            <h6>{language === "english" ? (
                                <>7. Term and Termination:</>
                            ) : (
                                <>7. المدة والإنهاء:</>
                            )
                            }
                            </h6>
                            <p></p>
                            <div className="defined-terms-list">
                                <div className="defined-terms-listcontent" >
                                    <span>{language === "english" ? (
                                        <>a.</>
                                    ) : (
                                        <>أ. </>
                                    )}</span>
                                    <p>{language === "english" ? (
                                        <>
                                            The term of the Agreement commences when you download or install the Application and will continue in effect until terminated by you or Hayat In L.L.C- S.P.C as set forth in this Section
                                        </>
                                    ) : (
                                        <>
                                            تبدأ مدة الاتفاقية عندما تقوم بتنزيل التطبيق أو تثبيته وستظل سارية حتى يتم إنهاؤها بواسطتك أو بواسطة شركة حياة إن كما هو منصوص عليه في هذا القسم
                                        </>
                                    )
                                    }
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent" >
                                    <span>{language === "english" ? (
                                        <>b.</>
                                    ) : (
                                        <>ب. </>
                                    )}</span>
                                    <p>{language === "english" ? (
                                        <>
                                            You may terminate this Agreement by deleting the Application and all copies thereof from your Mobile Device.
                                        </>
                                    ) : (
                                        <>
                                            يجوز لك إنهاء هذه الاتفاقية عن طريق حذف التطبيق وجميع نسخه من جهازك المحمول.
                                        </>
                                    )
                                    }
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent" >
                                    <span>{language === "english" ? (
                                        <>c.</>
                                    ) : (
                                        <>ت. </>
                                    )}</span>
                                    <p>{language === "english" ? (
                                        <>
                                            Hayat In L.L.C- S.P.C may terminate this Agreement at any time without notice. In addition, this Agreement will terminate immediately and automatically without any notice if you violate any of the terms and conditions of this Agreement.
                                        </>
                                    ) : (
                                        <>
                                            يجوز لشركة حياة إن إنهاء هذه الاتفاقية في أي وقت دون إشعار مسبق. بالإضافة إلى ذلك، سيتم إنهاء هذه الاتفاقية فورًا وتلقائيًا دون أي إشعار في حالة انتهاك أي من شروط وأحكام هذه الاتفاقية.
                                        </>
                                    )
                                    }
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span>{language === "english" ? (
                                        <>d.</>
                                    ) : (
                                        <>ث. </>
                                    )}</span>
                                    <div className="defined-terms-text">
                                        <p>{language === "english" ? (
                                            <>
                                                Upon termination:
                                            </>
                                        ) : (
                                            <>
                                                عند الانتهاء:
                                            </>
                                        )
                                        }
                                        </p>
                                        <div className="inner-content-5th-term">
                                            <p>{language === "english" ? (
                                                <>
                                                    i.	all rights granted to you under this Agreement will also terminate; and
                                                </>
                                            ) : (
                                                <>
                                                    i. سيتم أيضًا إنهاء جميع الحقوق الممنوحة لك بموجب هذه الاتفاقية؛ و
                                                </>
                                            )
                                            }
                                            </p>
                                            <p>{language === "english" ? (
                                                <>
                                                    ii.	you must cease all use of the Application and delete all copies of the Application from your Mobile Device and account.
                                                </>
                                            ) : (
                                                <>
                                                    ii. يجب عليك التوقف عن استخدام التطبيق وحذف جميع نسخ التطبيق من جهازك المحمول وحسابك.
                                                </>
                                            )
                                            }
                                            </p>

                                        </div>
                                    </div>
                                </div>

                                <div className="defined-terms-listcontent" >
                                    <span>{language === "english" ? (
                                        <>e.</>
                                    ) : (
                                        <>ج. </>
                                    )}</span>
                                    <p>{language === "english" ? (
                                        <>
                                            Termination will not limit any of Hayat In L.L.C- S.P.C 's rights or remedies at law or in equity.
                                        </>
                                    ) : (
                                        <>
                                            لن يحد الإنهاء من أي من حقوق أو تعويضات شركة حياة إن بموجب القانون أو حقوق الملكية.
                                        </>
                                    )
                                    }
                                    </p>
                                </div>

                            </div>
                        </div>

                        <div className="defined-terms">
                            <h6>{language === "english" ? (
                                <>8. Disclaimer of Warranties:</>
                            ) : (
                                <>8. إخلاء المسؤولية عن الضمانات:</>
                            )
                            }
                            </h6>
                            <p>
                                {language === "english" ? (
                                    <>THE APPLICATION IS PROVIDED TO END USER "AS IS" AND WITH ALL FAULTS AND DEFECTS WITHOUT WARRANTY OF ANY KIND. TO THE MAXIMUM EXTENT PERMITTED UNDER APPLICABLE LAW, HAYAT INL.L.C- S.P.C, ON ITS OWN BEHALF AND ON BEHALF OF ITS AFFILIATES AND ITS AND THEIR RESPECTIVE LICENSORS AND SERVICE PROVIDERS, EXPRESSLY DISCLAIMS ALL WARRANTIES, WHETHER EXPRESS, IMPLIED, STATUTORY, OR OTHERWISE, WITH RESPECT TO THE APPLICATION, INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE, AND NON-INFRINGEMENT, AND WARRANTIES THAT MAY ARISE OUT OF COURSE OF DEALING, COURSE OF PERFORMANCE, USAGE, OR TRADE PRACTICE. WITHOUT LIMITATION TO THE FOREGOING, HAYAT INL.L.C- S.P.C PROVIDES NO WARRANTY OR UNDERTAKING, AND MAKES NO REPRESENTATION OF ANY KIND THAT THE APPLICATION WILL MEET YOUR REQUIREMENTS, ACHIEVE ANY INTENDED RESULTS, BE COMPATIBLE, OR WORK WITH ANY OTHER SOFTWARE, APPLICATIONS, SYSTEMS, OR SERVICES, OPERATE WITHOUT INTERRUPTION, MEET ANY PERFORMANCE OR RELIABILITY STANDARDS, OR BE ERROR-FREE, OR THAT ANY ERRORS OR DEFECTS CAN OR WILL BE CORRECTED.</>
                                ) : (
                                    <>يتم تقديم التطبيق للمستخدم النهائي "كما هو" وبكل العيوب دون ضمان من أي نوع. إلى الحد الأقصى المسموح به بموجب القانون المعمول به، تتنصل شركة حياة إن، بالنيابة عنها وبالنيابة عن الشركات التابعة لها والمرخصين ومقدمي الخدمات التابعين لها، صراحةً من جميع الضمانات، سواء كانت صريحة أو ضمنية، أو غير ذلك، فيما يتعلق بالتطبيق، بما في ذلك جميع الضمانات الضمنية الخاصة بقابلية التسويق، والملاءمة لغرض معين، والملكية، وعدم الانتهاك، والضمانات التي قد تنشأ عن سياق التعامل، أو مسار الأداء، أو الاستخدام، أو الممارسة التجارية. دون تقييد ما سبق، لا تقدم  شركة حياة إن، أي ضمان أو تعهد، ولا تقدم أي تعهد من أي نوع بأن التطبيق سوف يلبي متطلباتك، أو يحقق أي نتائج مقصودة، أو يكون متوافقًا، أو يعمل مع أي برنامج آخرى أوالأنظمة ، أو الخدمات، أو تعمل دون انقطاع، أو تفي بأي معايير للأداء أو الموثوقية، أو تكون خالية من الأخطاء، أو يمكن أو سيتم تصحيح أي أخطاء أو عيوب. </>
                                )
                                }
                            </p>

                            <p>
                                {language === "english" ? (
                                    <>SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OF OR LIMITATIONS ON IMPLIED WARRANTIES OR THE LIMITATIONS ON THE APPLICABLE STATUTORY RIGHTS OF A CONSUMER, SO SOME OR ALL OF THE ABOVE EXCLUSIONS AND LIMITATIONS MAY NOT APPLY TO YOU.</>
                                ) : (
                                    <>لا تسمح بعض السلطات القضائية باستثناء أو فرض قيود على الضمانات الضمنية أو القيود على الحقوق القانونية المعمول بها للمستهلك، لذلك قد لا تنطبق عليك بعض أو كل الاستثناءات والقيود المذكورة أعلاه.</>
                                )
                                }
                            </p>

                        </div>

                        <div className="defined-terms">
                            <h6>{language === "english" ? (
                                <>9. Limitation of Liability:</>
                            ) : (
                                <>9. حدود المسؤولية:</>
                            )
                            }
                            </h6>
                            <p>{language === "english" ? (
                                <>TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT WILL HAYAT INL.L.C- S.P.COR ITS AFFILIATES, OR ANY OF ITS OR THEIR RESPECTIVE LICENSORS OR SERVICE PROVIDERS, HAVE ANY LIABILITY ARISING FROM OR RELATED TO YOUR USE OF OR INABILITY TO USE THE APPLICATION FOR:</>
                            ) : (
                                <> إلى أقصى حد يسمح به القانون المعمول به، لن تتحمل شركة حياة إن أو الشركات التابعة لها أو أي من المرخصين أو مقدمي الخدمات التابعين لها أو أي مسؤولية تنشأ عن أو تتعلق باستخدامك أو عدم قدرتك على استخدم تطبيق ل:</>
                            )
                            }</p>
                            <div className="defined-terms-list">
                                <div className="defined-terms-listcontent" >
                                    <span>{language === "english" ? (
                                        <>a.</>
                                    ) : (
                                        <>أ. </>
                                    )}</span>
                                    <p>{language === "english" ? (
                                        <>
                                            PERSONAL INJURY, PROPERTY DAMAGE, LOST PROFITS, COST OF SUBSTITUTE GOODS OR SERVICES, LOSS OF DATA, LOSS OF GOODWILL, BUSINESS INTERRUPTION, COMPUTER FAILURE OR MALFUNCTION, OR ANY OTHER CONSEQUENTIAL, INCIDENTAL, INDIRECT, EXEMPLARY, SPECIAL, OR PUNITIVE DAMAGES.
                                        </>
                                    ) : (
                                        <>الإصابة الشخصية، أو الأضرار التي تلحق بالممتلكات، أو خسارة الأرباح، أو تكلفة السلع أو الخدمات البديلة، أو فقدان البيانات، أو فقدان السمعة الطيبة، أو انقطاع الأعمال، أو عطل أو خلل في الكمبيوتر، أو أي شيء آخر لاحق أو عرضي أو غير مباشر أو نموذجي أو خاص أوالاضرر التأديبية الكاملة.</>
                                    )
                                    }
                                    </p>
                                </div>
                                <div className="defined-terms-listcontent" >
                                    <span>{language === "english" ? (
                                        <>b.</>
                                    ) : (
                                        <>ب. </>
                                    )}</span>
                                    <p>{language === "english" ? (
                                        <>
                                            DIRECT DAMAGES IN AMOUNTS THAT IN THE AGGREGATE EXCEED THE AMOUNT ACTUALLY PAID BY YOU FOR THE APPLICATION. <br /><br />
                                            THE FOREGOING LIMITATIONS WILL APPLY WHETHER SUCH DAMAGES ARISE OUT OF BREACH OF CONTRACT, TORT (INCLUDING NEGLIGENCE), OR OTHERWISE AND REGARDLESS OF WHETHER SUCH DAMAGES WERE FORESEEABLE OR HAYAT INL.L.C- S.P.CWAS ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. SOME JURISDICTIONS DO NOT ALLOW CERTAIN LIMITATIONS OF LIABILITY SO SOME OR ALL OF THE ABOVE LIMITATIONS OF LIABILITY MAY NOT APPLY TO YOU.
                                        </>
                                    ) : (
                                        <>
                                            الأضرار المباشرة بمبالغ تتجاوز في مجملها المبلغ الذي دفعته فعليًا مقابل تقديم الطلب. <br /><br />
                                            سيتم تطبيق القيود السابقة سواء كانت هذه الأضرار ناجمة عن خرق العقد أو الضرر (بما في ذلك الإهمال) أو غير ذلك، وبغض النظر عما إذا كانت هذه الأضرار متوقعة أو تم إخطار شركة حياة إن بإمكانية حدوث مثل هذا الاضرار. لا تسمح بعض السلطات القضائية بفرض قيود معينة على المسؤولية، لذا قد لا تنطبق عليك بعض أو كل حدود المسؤولية المذكورة أعلاه.
                                        </>
                                    )
                                    }
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="defined-terms">
                            <h6>{language === "english" ? (
                                <>10. Indemnification:</>
                            ) : (
                                <>10. التعويض:</>
                            )
                            }
                            </h6>
                            <p>{language === "english" ? (
                                <>
                                    You agree to indemnify, defend, and hold harmless Hayat In L.L.C- S.P.C and its officers, directors, employees, agents, affiliates, successors and assigns from and against any and all losses, damages, liabilities, deficiencies, claims, actions, judgments, settlements, interest, awards, penalties, fines, costs, or expenses of whatever kind, including reasonable attorneys' fees, arising from or relating to your use or misuse of the Application or your breach of this Agreement, including but not limited to the content you submit or make available through this Application.
                                </>
                            ) : (
                                <>
                                    أنت توافق على تعويض شركة حياة إن والدفاع عنها وحمايتها ومسؤوليها ومديريها وموظفيها ووكلائها والشركات التابعة لها وخلفائها والمتنازل لهم من وضد أي وجميع الخسائر والأضرار والالتزامات وأوجه القصور والمطالبات والإجراءات والأحكام، التسويات أو الفوائد أو الجوائز أو العقوبات أو الغرامات أو التكاليف أو النفقات من أي نوع، بما في ذلك أتعاب المحاماة المعقولة، الناشئة عن أو المتعلقة باستخدامك أو إساءة استخدام التطبيق أو خرقك لهذه الاتفاقية، بما في ذلك على سبيل المثال لا الحصر المحتوى التي تقدمها أو توفرها من خلال هذا التطبيق.
                                </>
                            )
                            }
                            </p>
                        </div>

                        <div className="defined-terms">
                            <h6>{language === "english" ? (
                                <>11. Export Regulation:</>
                            ) : (
                                <>11. لائحة التصدير:</>
                            )
                            }
                            </h6>
                            <p>{language === "english" ? (
                                <>
                                    You are strictly prohibited from directly or indirectly exporting, re-exporting, or releasing the Application to any jurisdiction or country where such actions are prohibited by law, rule, or regulation. Compliance with all applicable export control and sanction laws and regulations, including restrictions concerning destinations, users, and intended usage, is mandatory for your usage of the Application. Before exporting, re-exporting, releasing, or otherwise making the Application available, you must adhere to all applicable laws, regulations, and rules, and complete all required undertakings, including obtaining any necessary export license or other governmental approval.
                                </>
                            ) : (
                                <>
                                    يُحظر عليك تمامًا تصدير التطبيق أو إعادة تصديره أو إطلاقه بشكل مباشر أو غير مباشر إلى أي ولاية قضائية أو دولة يُحظر فيها مثل هذه الإجراءات بموجب القانون أو القاعدة أو اللوائح. يعد الامتثال لجميع قوانين ولوائح مراقبة الصادرات والعقوبات المعمول بها، بما في ذلك القيود المتعلقة بالوجهات والمستخدمين والاستخدام المقصود، أمرًا إلزاميًا لاستخدامك للتطبيق. قبل تصدير التطبيق أو إعادة تصديره أو إطلاقه أو إتاحته بطريقة أخرى، يجب عليك الالتزام بجميع القوانين واللوائح والقواعد المعمول بها، وإكمال جميع التعهدات المطلوبة، بما في ذلك الحصول على أي ترخيص تصدير ضروري أو موافقة حكومية أخرى.
                                </>
                            )
                            }
                            </p>

                        </div>

                        <div className="defined-terms">
                            <h6>{language === "english" ? (
                                <>12. Alcohol-Related Content Access Restrictions:</>
                            ) : (
                                <>12. قيود الوصول إلى المحتوى المتعلق بالكحول:</>
                            )
                            }
                            </h6>
                            <p>{language === "english" ? (
                                <>
                                    The Application may feature content, features, products, or services associated with alcohol. Access to this section is restricted to individuals who meet the legal age requirements for purchasing alcohol in both their country of residence and the country from which they access the app. Failure to meet these criteria may constitute a breach of laws or regulations in your country. Therefore, accessing this content is strictly prohibited. Suppose you opt to access it in contravention of applicable laws or regulations. In that case, you acknowledge and assume the associated risks, releasing Hayat In L.L.C- S.P.C, its affiliates, licensors, or service providers from any liability stemming from such actions.
                                </>
                            ) : (
                                <>
                                    قد يشتمل التطبيق على محتوى أو ميزات أو منتجات أو خدمات مرتبطة بالكحول. يقتصر الوصول إلى هذا القسم على الأفراد الذين يستوفون متطلبات السن القانوني لشراء الكحول في بلد إقامتهم أوالبلد الذي يصلون منه إلى التطبيق. قد يشكل عدم استيفاء هذه المعايير انتهاكًا للقوانين أو اللوائح في بلدك. ولذلك، فإن الوصول إلى هذا المحتوى ممنوع منعا باتا. إذا اخترت الوصول إليها بشكل يتعارض مع القوانين أو اللوائح المعمول بها، فإنك تقر وتتحمل المخاطر المرتبطة بها، وتحرر شركة حياة إن أو الشركات التابعة لها أو الجهات المرخصة لها أو مقدمي الخدمات من أي مسؤولية ناجمة عن مثل هذه الإجراءات.
                                </>
                            )
                            }</p>
                        </div>

                        <div className="defined-terms">
                            <h6>{language === "english" ? (
                                <>13. Severability:</>
                            ) : (
                                <>13. قابلية الفصل:</>
                            )
                            }</h6>
                            <p>{language === "english" ? (
                                <>
                                    Suppose any provision of this Agreement is illegal or unenforceable under applicable law. In that case, the remainder of the provision will be amended to achieve as closely as possible the effect of the original term, and all other provisions of this Agreement will continue in full force and effect.                                </>
                            ) : (
                                <>
                                    إذا كان أي حكم من أحكام هذه الاتفاقية غير قانوني أو غير قابل للتنفيذ بموجب القانون المعمول به، فسيتم تعديل باقي الاحكام لتحقيق أكبر قدر ممكن من تأثير الشرط الأصلي، وستظل جميع الأحكام الأخرى في هذه الاتفاقية سارية بكامل قوتها وتأثيرها.
                                </>
                            )
                            }
                            </p>
                        </div>

                        <div className="defined-terms">
                            <h6>{language === "english" ? (
                                <>14.Governing Law:</>
                            ) : (
                                <>14. القانون الحاكم:</>
                            )
                            }</h6>
                            <p>{language === "english" ? (
                                <>
                                    This Agreement is governed by and construed in accordance with the laws of the Dubai International Financial Centre, without giving effect to any choice or conflict of law provision or rule. Any legal suit, action, or proceeding arising out of or related to this Agreement or the Application shall be exclusively instituted in the courts of the Dubai International Financial Centre. However, we reserve the right to bring any suit, action, or proceeding against you for breach of the Agreement in your jurisdiction of residence or any other relevant jurisdiction. By accepting this Agreement, you waive any objections to the jurisdiction of such courts and consent to venue in such courts. Any arbitration award shall be final and binding upon the Parties and may be enforced by any court having jurisdiction in the same manner as a judgment. The parties’ confidentiality obligations under this Agreement extend to the arbitration proceedings and documentation.
                                </>
                            ) : (
                                <>
                                    تخضع هذه الاتفاقية وتفسر وفقًا لقوانين مركز دبي المالي العالمي، دون تفعيل أي خيار أو تعارض مع أحكام القانون أو القواعد. يتم رفع أي دعوى قانونية أو إجراء ينشأ عن أو يتعلق بهذه الاتفاقية أو التطبيق حصريًا في محاكم مركز دبي المالي العالمي. ومع ذلك، فإننا نحتفظ بالحق في رفع أي دعوى أو إجراء أو إجراء ضدك بسبب خرق الاتفاقية في نطاق الولاية القضائية التي تقيم فيها أو أي ولاية قضائية أخرى ذات صلة. من خلال قبول هذه الاتفاقية، فإنك تتنازل عن أي اعتراضات على اختصاص هذه المحاكم وتوافق على إقامة الدعوى أمام هذه المحاكم. يكون أي قرار تحكيم نهائيًا وملزمًا للأطراف ويمكن تنفيذه من قبل أي محكمة ذات اختصاص بنفس طريقة تنفيذ الحكم. تمتد التزامات السرية الخاصة بالطرفين بموجب هذه الاتفاقية إلى إجراءات التحكيم والوثائق.
                                </>
                            )}</p>
                        </div>

                        <div className="defined-terms">
                            <h6>{language === "english" ? (
                                <>15. Entire Agreement:</>
                            ) : (
                                <>15. الاتفاقية الكاملة :</>
                            )
                            }</h6>
                            <p>
                                {language === "english" ? (
                                    <>
                                        This Agreement, our <a href="#Terms of Use" className="hayat-link">Terms of Use</a>, <a href="#Terms of Sale" className="hayat-link">Terms of Sale</a>, <a href="#Rules of Use" className="hayat-link">Rules of Use</a>, and our <a href="#Privacy Policy" className="hayat-link">Privacy Policy</a> constitute the entire agreement between you and Hayat In L.L.C- S.P.C with respect to the Application and supersede all prior or contemporaneous understandings and agreements, whether written or oral, with respect to the Application.
                                    </>
                                ) : (
                                    <>
                                        تشكل هذه الاتفاقية و<a href="#Terms of Use" className="hayat-link">شروط الاستخدام</a> و<a href="#Terms of Sale" className="hayat-link">شروط البيع</a> و<a href="#Rules of Use" className="hayat-link">قواعد الاستخدام</a> و<a href="#Privacy Policy" className="hayat-link">سياسة الخصوصية</a> الخاصة بنا الاتفاقية الكاملة بينك وبين شركة حياة إن فيما يتعلق بالتطبيق وتحل محل جميع التفاهمات والاتفاقيات السابقة أو المعاصرة، سواء كانت مكتوبة أو شفهيًا، فيما يتعلق بالتطبيق.
                                    </>
                                )}
                            </p>

                        </div>
                        <div className="defined-terms">
                            <h6>{language === "english" ? (
                                <>16. Waiver:</>
                            ) : (
                                <>16. التنازل:</>
                            )
                            }</h6>
                            <p>{language === "english" ? (
                                <>
                                    No failure to exercise, and no delay in exercising, on the part of either party, any right or any power hereunder shall operate as a waiver thereof, nor shall any single or partial exercise of any right or power hereunder preclude further exercise of that or any other right hereunder. In the event of a conflict between this Agreement and any applicable law, regulation, or policy, the applicable law, regulation, or policy shall prevail to the extent of the conflict. However, all other provisions of this Agreement shall remain in full force and effect. If any provision of this Agreement is found to be invalid or unenforceable, the remaining provisions shall continue to be valid and enforceable in accordance with their terms.                                </>
                            ) : (
                                <>
                                    لا يجوز أن يكون أي إخفاق في ممارسة، أو تأخير في ممارسة، من جانب أي من الطرفين، أي حق أو أي سلطة بموجب هذه الاتفاقية بمثابة تنازل عنه، ولا يجوز أن تمنع أي ممارسة فردية أو جزئية لأي حق أو سلطة بموجب هذه الاتفاقية ممارسة أخرى لذلك أو أي حق آخر بموجب هذه الاتفاقية. في حالة وجود تعارض بين هذه الاتفاقية وأي قانون أو لائحة أو سياسة معمول بها، فإن القانون أو اللائحة أو السياسة المعمول بها هي التي تسود إلى حد التعارض. ومع ذلك، تظل جميع الأحكام الأخرى في هذه الاتفاقية سارية المفعول والتأثير بالكامل. إذا تبين أن أي حكم من أحكام هذه الاتفاقية غير صالح أو غير قابل للتنفيذ، فستظل الأحكام المتبقية سارية وقابلة للتنفيذ وفقًا لشروطها.
                                </>
                            )}</p>
                        </div>




                    </div>
                </main>

            </div>
        </div>
    );
};

export default SubmissionGuidelines